import React from "react";
import moment from "moment";


export const formatDateTime = (value) => {
    const parsed = value ? moment(value, [ "YYYY-MM-DD HH:mm:ss", moment.ISO_8601 ], true) : null;

    return parsed?.isValid() ? parsed.format("DD.MM.YYYY HH:mm") : "—";
};

const StaffManagementPeriodField = ({ startAt, endAt }) => (
    <span className="d-flex flex-column staff-management-list__period">
        <span>{ formatDateTime(startAt) } -</span>
        <span>{ formatDateTime(endAt) }</span>
    </span>
);

export default StaffManagementPeriodField;
